__turbopack_context__.v({
  "--flow-grid": "photo-gallery-submission-cta-module-scss-module__G94arW__--flow-grid",
  "--flow-masonry": "photo-gallery-submission-cta-module-scss-module__G94arW__--flow-masonry",
  "--scroll": "photo-gallery-submission-cta-module-scss-module__G94arW__--scroll",
  "--scroll-centered": "photo-gallery-submission-cta-module-scss-module__G94arW__--scroll-centered",
  "__call-to-action-button": "photo-gallery-submission-cta-module-scss-module__G94arW____call-to-action-button",
  "__content": "photo-gallery-submission-cta-module-scss-module__G94arW____content",
  "__customer-image": "photo-gallery-submission-cta-module-scss-module__G94arW____customer-image",
  "__customer-name": "photo-gallery-submission-cta-module-scss-module__G94arW____customer-name",
  "__description": "photo-gallery-submission-cta-module-scss-module__G94arW____description",
  "__fake-button": "photo-gallery-submission-cta-module-scss-module__G94arW____fake-button",
  "__footer": "photo-gallery-submission-cta-module-scss-module__G94arW____footer",
  "__logo-and-title": "photo-gallery-submission-cta-module-scss-module__G94arW____logo-and-title",
  "__text-container": "photo-gallery-submission-cta-module-scss-module__G94arW____text-container",
  "call-to-action-item": "photo-gallery-submission-cta-module-scss-module__G94arW__call-to-action-item",
});
